// Copied from the mobile app's features/sky/starScatter.ts with the types removed.
// Change the two together, for the reason given in star_layout.js.
import { hashSeed, mulberry32 } from "./random.js";

export function scatterStarAnchors(ids, seed, width, height) {
  if (ids.length === 0) return [];
  if (ids.length === 1) return [{ x: 0.5, y: 0.32 }];
  const spacing = Math.max(52, Math.min(120, Math.sqrt((width * height) / ids.length) * 0.78));
  const placed = [];
  for (const id of ids) {
    const rng = mulberry32(hashSeed(`${seed}/${id}/scatter`));
    let best = { x: 0.35 + rng() * 0.3, y: 0.18 + rng() * 0.28 };
    if (placed.length > 0) {
      let bestDistance = -1;
      for (let sample = 0; sample < 256; sample++) {
        const point = { x: rng(), y: rng() };
        const distance = Math.min(
          ...placed.map((other) => Math.hypot((point.x - other.x) * width, (point.y - other.y) * height))
        );
        if (distance > bestDistance) {
          best = point;
          bestDistance = distance;
        }
        if (distance >= spacing) break;
      }
    }
    placed.push(best);
  }
  return placed;
}
